import api from "../../config/api";

const state = {
    requestAssistanceResponse: ''
}
const mutations = {
    SET_REQUEST_ASSISTANCE_RESPONSE(state, payload) {
        state.requestAssistanceResponse = payload;
    },
}

const actions = {

    async submitRequestAssistance({ commit }, { message, topic }) {
        try {
            const response = await api.post(`/personajax`, {
                cmd: "requestassistance",
                message: message,
                topic: topic,
            });
            commit('SET_REQUEST_ASSISTANCE_RESPONSE', response.data);
            return response.data;
        } catch (error) {
            console.error('Error submitting request assistance:', error);
            throw error;
        }
    }

}

const getters = {
    stRequestAssistanceResponse: state => state.requestAssistanceResponse,
}

export default {
    state,
    mutations,
    actions,
    getters
}